import React from "react"

export interface FilterSearchInputProps {
  value: string
  onChange: (value: string) => void
  onFocus?: () => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  placeholder?: string
  id?: string
  label?: string
  className?: string
}

export function FilterSearchInput({
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  placeholder,
  id,
  label,
  className,
}: FilterSearchInputProps) {
  return (
    <>
      {label && (
        <label className="sr-only" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        id={id}
        type="text"
        className={className || "h-input h-input--block"}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
    </>
  )
}
